export function mailSupport(){
    window.open("mailto:support@mlveda.com")
}